module.exports = __webpack_public_path__ + "static/media/Login_resize.921df7ea.jpg";